

































































































































































































































































































































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectBox} from '@/interfaces/global-data';
import {
  FtpDownloadProgress,
  GetTaskInfo,
  ResultTableHeaders,
  TaskAndFile,
  TaskData,
  TaskInfoFilterType,
  TaskNoteDTO,
  TaskParams,
  TaskStatus,
  TaskType,
  taskTypesRequiresConfirmation,
  isTaskInBackgroundGeneratableTypesAndStatuses,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskType, localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import Card from '@/components/UI/Card.vue';

@Component({
    components: {
        ResultView,
        MultiSelect,
        MarketSelect,
        vSelect,
        DatePicker,
        Card,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY HH:mm:ss');
            }
        },
    },
    methods: {
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class Results extends Mixins(LocalData, Toast, Http) {
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('shared.selectBox.all') as string}];
    taskIdFilter: string | null = null;
    taskNoteFilter: string | null = null;
    allReportsIds: number[] = [];
    isAllReportsSelected: boolean = false;
    selectedReportsArray: number[] = [];
    updatedDateRange: string[] = [];
    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.notSelected') as string};
    defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

    selectMarket: number = this.defaultFilterValue.value;
    items: Array<SelectBox<number>> = [];

    categoryOptions: Array<SelectBox<number>> = [];
    categoryOfProduct: number = this.defaultFilterValue.value;

    subCategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;
    subCategoryOfProduct: number[] = [];

    selectGroup: number = this.defaultFilterValue.value;
    groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectFormat: number = this.defaultFilterValue.value;
    formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectRegion: number[] = [];
    regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectCluster: number = this.defaultFilterValue.value;
    clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectReportType: TaskType | null = null;
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = 'All';

    table: TaskData[] = [];
    refreshTableTimeoutId?: number;

    isTableLoading: boolean = false;
    isTableLoadingFirst: boolean = true;

    reportList: Array<SelectBox<TaskType | null>> = [
        {value: null, label: this.$t('fixedPrices.results.reportTypes.all') as string},
        {value: TaskType.REGULAR, label: this.$t('fixedPrices.results.reportTypes.regular') as string},
        {value: TaskType.PACKAGE_REGULAR, label: this.$t('fixedPrices.results.reportTypes.package') as string},
        {value: TaskType.PACKAGE_GENERAL, label: this.$t('fixedPrices.results.reportTypes.packageGeneral') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_CARTS, label: this.$t('fixedPrices.results.reportTypes.packageByCart') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS, label: this.$t('fixedPrices.results.reportTypes.packageSearchKvi') as string},
        {value: TaskType.PACKAGE_PROMO, label: this.$t('fixedPrices.results.reportTypes.packagePromo') as string},
        {value: TaskType.PACKAGE_GENERAL_PROMO, label: this.$t('fixedPrices.results.reportTypes.packagePromoGeneral') as string},
        {value: TaskType.PACKAGE_SCHEDULE, label: this.$t('fixedPrices.results.reportTypes.bySchedule') as string},
        {value: TaskType.BRUT_FORCE, label: this.$t('fixedPrices.results.reportTypes.parameterSearch') as string},
        {value: TaskType.SEARCH_KVI, label: this.$t('fixedPrices.results.reportTypes.searchKvi') as string},
        {value: TaskType.PROMO, label: this.$t('fixedPrices.results.reportTypes.promo') as string},
        {value: TaskType.PACKAGE_EVENTS, label: this.$t('fixedPrices.results.reportTypes.eventCalc') as string},
        {value: TaskType.PACKAGE_EVENTS_GENERAL, label: this.$t('fixedPrices.results.reportTypes.eventCalcGeneral') as string},
        {value: TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS, label: this.$t('fixedPrices.results.reportTypes.promoRecommendations') as string},
        {value: TaskType.PACKAGE_SCENARIO, label: this.$t('fixedPrices.results.reportTypes.scenario') as string},
        {value: TaskType.PACKAGE_GENERAL_SCENARIO, label: this.$t('fixedPrices.results.reportTypes.scenarioGeneral') as string},
        {value: TaskType.PACKAGE_FIXED_PRICE, label: this.$t('fixedPrices.results.reportTypes.packageFixedPrice') as string},
        {value: TaskType.PACKAGE_GENERAL_FIXED_PRICE, label: this.$t('fixedPrices.results.reportTypes.packageGeneralFixedPrice') as string},
        {value: TaskType.REGULAR_PRICE_EXP, label: this.$t('fixedPrices.results.reportTypes.regularPriceExp') as string},
        {value: TaskType.SCHEDULED_PRICE_EXP, label: this.$t('fixedPrices.results.reportTypes.scheduledPriceExp') as string},
    ];

    selectStatus: TaskStatus | null = null;
    statusList: Array<SelectBox<TaskStatus | null>> = [
        {value: null, label: this.$t('fixedPrices.results.taskStatuses.all') as string},
        {value: TaskStatus.ARITHMETICEXCEPTION, label: this.$t('fixedPrices.results.taskStatuses.arithmeticError') as string},
        {value: TaskStatus.INQUEUE, label: this.$t('fixedPrices.results.taskStatuses.inQueue') as string},
        {value: TaskStatus.WRITETOFILE, label: this.$t('fixedPrices.results.taskStatuses.writingToFile') as string},
        {value: TaskStatus.CALCULATING, label: this.$t('fixedPrices.results.taskStatuses.calculating') as string},
        {value: TaskStatus.ONAPPROVAL, label: this.$t('fixedPrices.results.taskStatuses.onApproval') as string},
        {value: TaskStatus.EMPTYDATA, label: this.$t('fixedPrices.results.taskStatuses.noData') as string},
        {value: TaskStatus.RESTARTERROR, label: this.$t('fixedPrices.results.taskStatuses.stopped') as string},
        {value: TaskStatus.REJECTED, label: this.$t('fixedPrices.results.taskStatuses.rejected') as string},
        {value: TaskStatus.PARTIALLY_REJECTED, label: this.$t('fixedPrices.results.taskStatuses.partiallyRejected') as string},
        {value: TaskStatus.WRITETOFILECOMPLETE, label: this.$t('fixedPrices.results.taskStatuses.reportWritten') as string},
        {value: TaskStatus.ERROREXPORT, label: this.$t('fixedPrices.results.taskStatuses.exportError') as string},
        {value: TaskStatus.ERROR, label: this.$t('fixedPrices.results.taskStatuses.error') as string},
        {value: TaskStatus.PROMONOTRECOMMENDED, label: this.$t('fixedPrices.results.taskStatuses.promoNotRecommended') as string},
        {value: TaskStatus.CALCULATING_COMPLETE, label: this.$t('fixedPrices.results.taskStatuses.calcComplete') as string},
        {value: TaskStatus.CANCELREPORT, label: this.$t('fixedPrices.results.taskStatuses.calcCancelled') as string},
        {value: TaskStatus.EXECUTIONEXCEPTION, label: this.$t('fixedPrices.results.taskStatuses.singularMatrix') as string},
        {value: TaskStatus.APPROVED, label: this.$t('fixedPrices.results.taskStatuses.approved') as string},
        {value: TaskStatus.PARTIALLY_APPROVED, label: this.$t('fixedPrices.results.taskStatuses.partiallyApproved') as string},
    ];

    tableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'id', label: this.$t('shared.labels.numberSign') as string},
        {key: 'message', label: this.$t('shared.labels.status') as string},
        {key: 'updated', label: this.$t('shared.labels.updateTime') as string},
        {key: 'userFio', label: this.$t('shared.labels.user') as string},
        {key: 'progress', label: this.$t('shared.labels.progress') as string},
        {key: 'tradingNetworks.tradingName', label: this.$t('shared.labels.company') as string},
        {key: 'type', label: this.$t('shared.labels.type') as string},
        {key: 'group', label: this.$t('shared.labels.group') as string},
        {key: 'category', label: this.$t('shared.labels.category') as string},
        {key: 'subcategories', label: this.$t('shared.labels.subcategories') as string},
        {key: 'format', label: this.$t('shared.filters.format') as string},
        {key: 'region', label: this.$t('shared.filters.region') as string},
        {key: 'cluster', label: this.$t('shared.filters.cluster') as string},
        {key: 'fileResult', label: this.$t('shared.table.actions') as string},
        {key: 'ftpSendingStatus', label: ''},
        {key: 'taskNote', label: this.$t('shared.labels.notes') as string},
        {key: 'taskNoteSecond', label: ''},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
        {dataIndex: 'fileResult', title: this.$t('shared.table.actions') as string, scopedSlots: { customRender: 'fileResult' }, fixed: 'left', stickyColumn: true, ellipsis: true, width: 200},
        {dataIndex: 'taskNote', title: this.$t('shared.labels.notes') as string, scopedSlots: { customRender: 'taskNote', filterDropdown: 'taskNoteFilter', filterIcon: "taskNoteFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'id', title: this.$t('shared.labels.numberSign') as string, scopedSlots: { filterDropdown: 'idFilter', filterIcon: "idFilterIcon" }, width: 80},
        {dataIndex: 'message', title: this.$t('shared.labels.status') as string, scopedSlots: { filterDropdown: 'messageFilter', filterIcon: "messageFilterIcon", customRender: 'message' }, ellipsis: true, width: 150},
        {dataIndex: 'updated', title: this.$t('shared.labels.updateTime') as string, customRender: (value: number) => new Date(value).toLocaleString('fr-FR'), scopedSlots: { filterDropdown: 'updatedFilter', filterIcon: "updatedFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'userFio', title: this.$t('shared.labels.user') as string, scopedSlots: { filterDropdown: 'userFioFilter', filterIcon: "userFioFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'progress', title: this.$t('shared.labels.progress') as string, scopedSlots: { customRender: 'progress' }, ellipsis: true, width: 100},
        {dataIndex: 'tradingNetworks.tradingName', title: this.$t('shared.labels.company') as string, scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'type', title: this.$t('shared.labels.type') as string, ellipsis: true, width: 150, customRender: (_: string, item: TaskData) => localizeTaskType(item.typeMachine)},
        {dataIndex: 'group', title: this.$t('shared.labels.group') as string, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'category', title: this.$t('shared.labels.category') as string, scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'subcategories', title: this.$t('shared.labels.subcategories') as string, customRender: (value: string[]) => value.join(', '), scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'format', title: this.$t('shared.filters.format') as string, scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'region', title: this.$t('shared.filters.region') as string, scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'cluster', title: this.$t('shared.filters.cluster') as string, scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" }, ellipsis: true, width: 120},

        {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }, width: 0},
    ];

    pagination: any = {
        pageSize: 20,
    };

    showSendToFTPSingleReportModal: boolean = false;
    taskToView: TaskAndFile | null = null;
    packageSubtask: TaskAndFile | null = null;
    perPage: number = 20;
    currentPage: number = 1;
    totalRows: number = 0;
    isActiveCalculatingReports: boolean = false;
    isExistsUnfinishedReports: boolean = false;
    showDeleteSingleReportModal: boolean = false;
    taskIdForDelete: number = -1;
    taskIdForSendToFTP: number = -1;
    timeout: number = 1000;
    currentMainTab: string = "list"
    buttonSectionLoaderMap: Map<number, boolean> = new Map<number, boolean>();

    getButtonSectionLoaderState(taskId: number): boolean {
      return this.buttonSectionLoaderMap.get(taskId) || false
    }

    setButtonSectionLoaderState(taskId: number, state: boolean) {
      this.buttonSectionLoaderMap.set(taskId, state);
    }

    private httpExecutor = new HttpExecutor();

    private canBeShowTypes = [TaskType.PACKAGE_REGULAR, TaskType.PACKAGE_SCHEDULE, TaskType.REGULAR, TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_SCENARIO, TaskType.PACKAGE_GENERAL_SCENARIO, TaskType.PACKAGE_EVENTS, TaskType.PACKAGE_EVENTS_GENERAL, TaskType.PACKAGE_GENERAL_KVI_CARTS,
        TaskType.PACKAGE_FIXED_PRICE, TaskType.PACKAGE_GENERAL_FIXED_PRICE, TaskType.SALES, TaskType.PACKAGE_SALES, TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES,
        TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION, TaskType.REGULAR_PRICE_EXP, TaskType.SCHEDULED_PRICE_EXP];

    created() {
        if (this.$disallowedModules.indexOf('promo') !== -1) {
            const index = this.reportList.findIndex((item) => {
                return item.value === TaskType.PROMO;
            });
            if (index !== -1) {
                this.reportList.splice(index, 1);
            }
        }
    }

    getLocalizedStatus(status: string): string {
        return localizeTaskStatus(status);
    }

    mounted() {
        EventBus.$on('calc', this.onCalcEventReceived);
        this.loadMarkets();
        this.checkUnfinishedAndCancelReports();
        EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        // Вызов идет из ResultView.vue. Работает, не трогать :)
        EventBus.$on('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
        if (this.$route.params.hasOwnProperty('id')) {
            this.viewReport(this.$route.params.id);
        }

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize
        }, () => {});
    }

    onTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {});
    }

    onCalcEventReceived(data: TaskData) {
        this.updateTaskRowStatus(data);
    }

    onPackageSubTaskViewEventReceived(task: ResultTableHeaders) {
        this.selectPackageResult(task);
    }

    onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
        console.log("onFtpDownloadProgressReceived")
        this.updateSendToFtpProgress(ftpSendProgress);
    }

    beforeDestroy() {
        clearTimeout(this.refreshTableTimeoutId)
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        EventBus.$off('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
    }

    updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
        const index = this.table.findIndex((item) => {
            return item.id === ftpSendProgress.taskId;
        });
        if (index !== -1) {
            this.table[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
        }
    }

    updateTaskRowStatus(data: TaskData) {
        const index = this.table.findIndex((item) => {
            return item.id === data.id;
        });
        if (index === -1) {
            this.table = [data, ...this.table];
            return;
        }
        this.table[index].message = data.message;
        this.table[index].updated = data.updated;
        this.table[index].fileResult = data.fileResult;
        this.table[index].progress = data.progress;
        this.table[index].status = data.status;
        this.checkUnfinishedAndCancelReports();
        // Костыль - обновляем страницу отчетов, т.к. Пакетный общий отчет создается с пустой группой, категорией и тд и только потом они подтягиваются в виде списка при загрузке страницы
        if (data.type === 'Пакетный общий' && data.status === 'WriteToFileComplete') {
            this.handleFilter();
        }
    }

    updateSelectMarket(market: number) {
        this.$log.debug('Calc updateSelectMarket', market);
        this.selectMarket = market;
        this.resetData(null);
        if (LocalData.zeroToNull(market) != null) {
            this.getGroupInfo();
            this.getCategoryInfo();
            this.getSubcategoryInfo();
            this.getStoreFormatsInfo();
            this.getStoreRegionsInfo();
            this.getStoreClustersInfo();
        }
    }

    onMainTabsClicked(key:string) {
        this.currentMainTab = key
        switch (key) {
            case "list":
                // @ts-ignore
                this.handleFilter()
                break;
            default:
                return
        }
    }

    showProgressBar(status: string): boolean {
        return status === 'Calculating'
                || status === 'CalculatingComplete'
                || status === 'WriteToFile';
    }

    showCancelReportsButton(): boolean {
        return !this.isActiveCalculatingReports || this.selectedReportsArray.length === 0;
    }

    showRestartReportsButton(): boolean {
        return !this.isExistsUnfinishedReports || this.selectedReportsArray.length === 0;
    }

    showCompleteMessage(status: string): boolean {
        return status === 'WriteToFileComplete';
    }

    showDeleteTaskButton(status: string): boolean {
        return (status === TaskStatus.WRITETOFILECOMPLETE
                || status === TaskStatus.EMPTYDATA
                || status === TaskStatus.PROMONOTRECOMMENDED
                || status === TaskStatus.EXECUTIONEXCEPTION
                || status.includes('Error')
                || status.includes('Exception')
                || status === TaskStatus.INQUEUE
                || status === TaskStatus.CANCELREPORT
                || status === TaskStatus.REJECTED
                || status === TaskStatus.ONAPPROVAL);
    }

    checkUnfinishedAndCancelReports() {
        this.httpCheckUnfinishedReports()
                .then((result) => {
                    this.isActiveCalculatingReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('fixedPrices.results.errorCheckUnfinished') as string);
                });

        this.httpCheckCancelReports()
                .then((result) => {
                    this.isExistsUnfinishedReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('fixedPrices.results.errorCheckCancelled') as string);
                });
    }

    cancelAllCalculatingReports(reportsArray: number[]) {
        this.httpCancelTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('fixedPrices.results.reportCancelled', { id }) as string);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('fixedPrices.results.errorCancelReport') as string);
                });
    }

    restartAllCalculatingReports(reportsArray: number[]) {
        this.httpRestartTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('fixedPrices.results.reportRestarted', { id }) as string);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('fixedPrices.results.errorRestartReport') as string);
                });
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    recalculateGeneralTask(generalTaskId: number) {
        this.httpRecalculateGeneralTask(generalTaskId)
                .then((result) => {
                    this.showInfo(this.$t('fixedPrices.results.reportRecalculating', { id: generalTaskId }) as string);
                    this.handleFilter();

                })
                .catch(() => {
                    this.showError(this.$t('fixedPrices.results.errorRecalculateReport') as string);
                });
    }

    beforeSendToFTPDialog(taskId: number) {
        this.showSendToFTPSingleReportModal = true
        this.taskIdForSendToFTP = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.deleteTask([taskId]);
    }

    showDeleteCheckedReports(taskIds: number[]) {
        this.deleteTask(taskIds);
        this.selectedReportsArray = [];
    }

    inputTaskNote(taskNoteParam: string, taskId: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            const taskParam: TaskNoteDTO = {
                taskNote: taskNoteParam,
            }
            this.httpCreateNote(taskId, taskParam);
        }, 500);
    }

    downloadFile(taskId: number, file: string) {
        this.$http.get('/api/task/result', {
            method: 'GET',
            responseType: 'blob',
            params: {
                taskId,
            },
        })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.endsWith('.xlsx') ? file : 'report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('fixedPrices.results.errorDownloadReport') as string);
                });
    }

    downloadFinalReportFile(taskId: number, file: string) {
      this.httpDownloadFinalReportFile(taskId, file)
    }

    generateReport(task: TaskData) {
      this.httpStartGeneratingReport(task.id)
          .then(() => {
            task.status = TaskStatus.WRITETOFILE
            this.refreshTable()
          })
    }

    downloadFiles(taskIds: number[]) {
        taskIds.forEach((id) => {
            const tableRow = this.table.find((item) => {
                return item.id === id
            });
            this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId: id,
                },
            })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', tableRow!!.fileResult);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('fixedPrices.results.errorDownloadReport') as string);
                    });
        });
    }

    deleteTask(taskIds: number[]) {
        this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    taskIds.forEach((id) => {
                        const index = this.table.findIndex((item) => {
                            return item.id === id
                        });
                        if (index !== -1) {
                            this.table.splice(index, 1);
                        }
                    });
                    this.taskToView = null;
                    this.checkUnfinishedAndCancelReports();
                })
                .catch((err) => {
                    this.showError(this.$t('fixedPrices.results.errorDeleteReport') as string);
                });
    }

    fetchList(ctx: any, callback: (items: any[]) => void) {
        const params: TaskParams = {
            size: ctx.perPage,
            page: ctx.currentPage - 1,
            type: TaskType.PACKAGE_GENERAL_FIXED_PRICE,
        };

        params.taskIdFilter = this.taskIdFilter
        params.taskNoteFilter = this.taskNoteFilter

        const userFio = this.selectUserFio;
        if (userFio != null && userFio !== 'All') {
            params.userFio = userFio;
        }

        const status = this.selectStatus;
        if (status != null) {
            params.status = status;
        }

        const company = LocalData.zeroToNull(this.selectMarket);
        if (company != null) {
            params.tradingId = company;
        }

        const type = this.selectReportType;
        if (type != null) {
            params.type = type;
        }

        const group = LocalData.zeroToNull(this.selectGroup);
        if (group != null) {
            params.group = group;
        }

        const category = LocalData.zeroToNull(this.categoryOfProduct);
        if (category != null) {
            params.category = category;
        }

        const subCategory = LocalData.filterNumberArrays(this.subCategoryOfProduct, true);
        if (subCategory != null) {
            params.subcategories = subCategory.join(',');
        }

        const storeFormat = LocalData.zeroToNull(this.selectFormat);
        if (storeFormat != null) {
            params.storeFormat = storeFormat;
        }

        const region = LocalData.filterNumberArrays(this.selectRegion, true);
        if (region != null) {
            params.storeRegions = region.join(',');
        }

        const cluster = LocalData.zeroToNull(this.selectCluster);
        if (cluster != null) {
            params.storeCluster = cluster;
        }
        if (this.updatedDateRange.length > 0) {
            params.dateBefore = this.updatedDateRange[0]
            params.dateAfter = this.updatedDateRange[1]
        }

        this.isTableLoading = true;

        this.httpGetTaskList(params)
                .then((response) => {
                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalElements;
                    this.pagination = pagination;
                    this.table = response.data.content;

                    if (this.table.length === 0) {
                        this.showInfo(this.$t('shared.messages.nothingFound') as string)
                    }
                    callback(response.data.content);
                    clearTimeout(this.refreshTableTimeoutId);
                    this.refreshTableTimeoutId = setTimeout(() => {this.fetchList(ctx, callback)}, 10000)
                })
                .catch((e) => {
                    this.showError(this.$t('fixedPrices.results.errorLoadReportList') as string);
                    callback([]);
                }).finally(() => {
                    this.isTableLoading = false;
                    this.isTableLoadingFirst = false;
                });

        if (this.usersFioList.length === 0) {
            this.httpGetUsersFio()
                    .then((response) => {
                        this.usersFioList = response.data.map((i) => {
                            return {value: i, label: i}
                        });
                        this.usersFioList.unshift({value: 'All', label: this.$t('shared.selectBox.all') as string});
                    })
                    .catch((e) => {
                        this.showError(this.$t('fixedPrices.results.errorLoadUsersFio') as string);
                    });
        }

        this.httpGetAllReportsIds(params)
                .then((response) => {
                    this.allReportsIds = response.data;
                })
                .catch((e) => {
                    this.showError(this.$t('fixedPrices.results.errorLoadReportIds') as string);
                });
    }

    selectOrClearAllReports(selected: boolean) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (selected) {
          this.isAllReportsSelected = true;
          this.selectedReportsArray = this.allReportsIds;
        } else {
          this.isAllReportsSelected = false;
          this.selectedReportsArray = [];
        }
      }, 100);
    }

    isSelectedTaskId(taskId: number) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        return index !== -1;
    }

    setSelectedTaskId(taskId: number, selected: boolean) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        if (selected) {
            if (index === -1) {
                this.selectedReportsArray.push(taskId);
            }
        } else {
            if (index !== -1) {
                this.selectedReportsArray.splice(index, 1);
            }
        }
    }

    loadMarkets() {
      this.httpLoadTradingNetworks(true)
          .then((json) => {
            // Основная сортировка
            const sortedItems = json.data
                .sort((a, b) => {
                  const isLatinA = /^[A-Za-z]/.test(a.tradingName);
                  const isLatinB = /^[A-Za-z]/.test(b.tradingName);

                  // Сначала латиница, потом кириллица
                  if (isLatinA && !isLatinB) return -1;
                  if (!isLatinA && isLatinB) return 1;

                  // Внутри каждой группы — алфавитно
                  return a.tradingName.localeCompare(b.tradingName, undefined, { sensitivity: 'base' });
                })
                .map((i) => ({
                  value: i.id,
                  label: i.tradingName,
                }));

            // Добавляем пункт "Все" в начало
            this.items = [{ value: -1, label: this.$t('shared.selectBox.all') as string }, ...sortedItems];
          })
          .catch((err) => {
            console.error('Ошибка при загрузке сетей:', err);
          });
    }


    moveFiltersToTableFilters(taskId: number) {
        this.showAction(
                this.$t('fixedPrices.results.setDefaultParamsConfirm') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.actions.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('fixedPrices.results.defaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('fixedPrices.results.errorSetDefaultParams', { id: taskId }) as string);
                                    });
                        },
                    }],
                });
    }

    moveFiltersToTableFiltersForCheckedReports(taskIds: number[]) {
        this.showAction(
                this.$t('fixedPrices.results.setBatchDefaultParamsConfirm') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.actions.yes') as string,
                        onClick: () => {
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('fixedPrices.results.defaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('fixedPrices.results.errorSetBatchDefaultParams') as string);
                                    });
                        },
                    }],
                });
    }

    sendFileToFtpServer(taskId: number) {
        this.setButtonSectionLoaderState(taskId, true)
        this.httpSendReportToFtpServer([taskId])
                .then((response) => {
                    this.fetchList({
                        currentPage: this.pagination.current,
                        perPage: this.pagination.pageSize,
                    }, () => {});
                    this.showInfo(this.$t('fixedPrices.results.reportSentForApproval') as string);
                })
                .catch((exception) => {
                    this.showError(this.$t('fixedPrices.results.errorSendForApproval') as string + exception.response.data.message);
                })
            .finally(() => {
              this.setButtonSectionLoaderState(taskId, false)
            });
    }

    sendFileToFtpServerForCheckedReports(taskIds: number[]) {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL
        });
        const filteredIds = filteredTable.map((task) => {
            return task.id
        });
        this.httpSendReportToFtpServer(filteredIds)
                .then((response) => {
                    this.showInfo(this.$t('fixedPrices.results.reportsSentForApproval') as string);
                })
                .catch((exception) => {
                    this.showError(this.$t('fixedPrices.results.errorSendBatchForApproval') as string + exception.response.data.message);
                });
    }

    canBeSendFileToFtpServerForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeSaveForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeMoveFiltersToTableFiltersForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.typeMachine !== TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS && task.typeMachine !== TaskType.SEARCH_KVI && task.typeMachine !== TaskType.PACKAGE_GENERAL
                    && task.typeMachine !== TaskType.PACKAGE_GENERAL_SCENARIO && task.typeMachine !== TaskType.PACKAGE_EVENTS_GENERAL && task.fileResult.length > 0 && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    clearFilters() {
        this.taskIdFilter = null;
        this.selectStatus = null;
        this.selectReportType = null;
        this.selectMarket = this.defaultFilterValue.value;
        this.selectGroup = this.defaultFilterValue.value;
        this.categoryOfProduct = this.defaultFilterValue.value;
        this.subCategoryOfProduct = [];
        this.selectFormat = this.defaultFilterValue.value;
        this.selectRegion = [];
        this.selectCluster = this.defaultFilterValue.value;
        this.categoryOptions = [this.defaultFilterValue];
        this.subCategoryOptions = this.defaultMultipleValue;
        this.formatOptions = this.defaultMultipleValue;
        this.regionOptions = this.defaultMultipleValue;
        this.clusterOptions = this.defaultMultipleValue;
        this.selectUserFio = 'All';
        this.updatedDateRange = [];
        this.taskNoteFilter = null;

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

    handleFilter() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

  onFilterButtonClick() {
      this.handleFilter();
      this.selectOrClearAllReports(this.isAllReportsSelected);
  }

    resetByGroup() {
        this.resetData(TaskInfoFilterType.group)
    }

    resetByCategory() {
        this.resetData(TaskInfoFilterType.category)
    }

    resetByStoreFormat() {
        this.resetData(TaskInfoFilterType.format)
    }

    resetByStoreCluster() {
        this.resetData(TaskInfoFilterType.cluster)
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.subCategoryOfProduct)) {
            this.subCategoryOfProduct = list;
            this.resetBySubcategory();
        } else if (this.subCategoryOfProduct[0] === 0) {
            this.subCategoryOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.selectRegion)) {
            this.selectRegion = list;
            this.resetByStoreRegion();
        } else if (this.selectRegion[0] === 0) {
            this.selectRegion = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    showStopButton(task: TaskData): boolean {
        return task.typeMachine === TaskType.BRUT_FORCE && task.status === TaskStatus.CALCULATING
    }

    showGenerateReportButton(task: TaskData): boolean {
      const isTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.fileResult.length && isTaskReadyToBeGenerated && !task.needRecalculatePackageTask
    }

    showDownloadButton(task: TaskData): boolean {
      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE
      ].map((v) => v.valueOf())

      return !!task.fileResult.length
          && !task.needRecalculatePackageTask
          && !(restrictedStatuses.includes(task.status))
    }

    showSetDefaultParamButton(task: TaskData): boolean {
      const restrictedTaskTypes = [
        TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS,
        TaskType.SEARCH_KVI,
        TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_SCENARIO,
        TaskType.PACKAGE_EVENTS_GENERAL,
      ]

      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.needRecalculatePackageTask
          && !restrictedTaskTypes.includes(task.typeMachine)
          && (task.fileResult.length > 0 || isPackageTaskReadyToBeGenerated)
    }

    showSaveFinalReportButton(task: TaskData): boolean {
        return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
    }

    showDownloadPriceButton(task: TaskData): boolean {
      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE,
        TaskStatus.APPROVED,
        TaskStatus.ONAPPROVAL
      ].map((v) => v.valueOf())

      return taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.typeMachine)
          && (!task.needRecalculatePackageTask && !restrictedStatuses.includes(task.status))
          && (!!task.fileResult.length || isPackageTaskReadyToBeGenerated)
    }

    stopBrutForcing(taskId: number) {
        this.httpExecutor.executeHttp(this.httpStopBrutForce, taskId)
                .then((r) => {
                    if (!r.ignore) {
                        this.refreshTable();
                        const resp = r.response;
                        if (resp.status === 204) {
                            this.showInfo(this.$t('fixedPrices.results.parameterSearchStopped') as string)
                        } else if (resp.status === 404) {
                            this.showInfo(this.$t('fixedPrices.results.parameterSearchNotFound') as string)
                        } else {
                            this.showError(this.$t('fixedPrices.results.errorStopParameterSearch') as string)
                        }
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('fixedPrices.results.errorStopParameterSearch') as string)
                })
    }

    canBeShown(task: TaskData): boolean {
        const found = this.canBeShowTypes.findIndex((type) => task.typeMachine === type)
        if (found === -1) {
            return false;
        }
        return !task.needRecalculatePackageTask && (task.status === 'WriteToFileComplete' || task.status === 'OnApproval' || task.status === 'Rejected' || task.status === 'Approved');
    }

    selectResult(isExpanded: boolean, task: TaskData) {
        this.$router.push(`/reports/${task.id}`)
        let subCategories = ' - ';
        if (task.subcategories.length > 0) {
            subCategories = task.subcategories + ' / '
        }

        let formatName = ' - ';
        if (task.format !== '') {
            formatName = task.format + ' / '
        }

        let regionName = ' - ';
        if (task.region !== '') {
            regionName = task.region + ' / '
        }

        let clusterName = ' - ';
        if (task.cluster !== '') {
            clusterName = task.cluster + ' / '
        }
        const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
        this.taskToView = {
            id: task.id,
            status: task.status,
            type: task.typeMachine,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        console.log(this.taskToView, "this.taskToView")

        // (this.$refs.resultViewTab as any).disabled = false;
        // (this.$refs.resultViewTab as any).activate();
        this.currentMainTab = "results"
    }

    selectPackageResult(task: ResultTableHeaders) {
        let subCategories = ' - ';
        if (task.subCategoryName !== '') {
            subCategories = task.subCategoryName + ' / '
        }

        let formatName = ' - ';
        if (task.formatName !== '') {
            formatName = task.formatName + ' / '
        }

        let regionName = ' - ';
        if (task.regionName !== '') {
            regionName = task.regionName + ' / '
        }

        let clusterName = ' - ';
        if (task.clusterName !== '') {
            clusterName = task.clusterName + ' / '
        }
        const filters = task.groupName + ' / ' + task.categoryName + ' / ' + subCategories + formatName + regionName + clusterName
        this.packageSubtask = {
            id: task.taskId,
            status: task.status,
            type: task.type,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        this.currentMainTab ="resultPackageViewTab"
        // (this.$refs.resultPackageViewTab as any).disabled = false;
        // (this.$refs.resultPackageViewTab as any).activate();
    }

    taskIdPrevent(e: any) {
        if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            return
        }
        if (!/^\d+$/.test(e.key)) {
            e.preventDefault();
        }
        this.refreshTable()
    }

    private refreshTable() {
        if (this.$route.params.hasOwnProperty('id')) {
            this.$router.push('/reports');
        }
        this.currentPage = 1;
        (this.$refs.tasksTable as any).refresh();
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        return {
            type: taskType,
            // tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectMarket!!,
            categories: LocalData.filterNumberArrays([this.categoryOfProduct], true),
            groups: LocalData.filterNumberArrays([this.selectGroup], true),
            subcategory: LocalData.filterNumberArrays(this.subCategoryOfProduct, true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays([this.selectFormat], true),
            storeCluster: LocalData.filterNumberArrays([this.selectCluster], true),
            storeRegion: LocalData.filterNumberArrays(this.selectRegion, true),
            byReports: true,
        }
    }

    private resetBySubcategory() {
        this.resetData(TaskInfoFilterType.subcategory)
    }

    private resetByStoreRegion() {
        this.resetData(TaskInfoFilterType.region)
    }

    private resetData(type: TaskInfoFilterType | null = null) {
        switch (type) {
            case null:
                this.selectGroup = this.defaultFilterValue.value;
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.groupOptions = this.defaultMultipleValue;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                break;
            case TaskInfoFilterType.group:
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getCategoryInfo();
                this.getSubcategoryInfo();
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.category:
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getSubcategoryInfo();
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.format:
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.region:
                this.selectCluster = this.defaultFilterValue.value;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreClustersInfo();
                break;
        }
    }

    private getGroupInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
          .then((data) => {
            const filterData = data.data;

            this.groupOptions = filterData.groups
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтные опции наверх
            this.groupOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
          })
          .catch((e) => {});
    }

    private getCategoryInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
          .then((data) => {
            const filterData = data.data;

            this.categoryOptions = filterData.categories
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтное значение в начало
            this.categoryOptions.unshift(this.defaultFilterValue);
          })
          .catch((e) => {
            console.error('Ошибка при загрузке категорий:', e);
          });
    }

    private getSubcategoryInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
          .then((data) => {
            const filterData = data.data;

            this.subCategoryOptions = filterData.subcategories
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтные значения в начало
            this.subCategoryOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
          })
          .catch((e) => {
            console.error('Ошибка при загрузке подкатегорий:', e);
          });
    }

    private getStoreFormatsInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
          .then((data) => {
            const filterData = data.data;

            this.formatOptions = filterData.storeFormat
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтные опции в начало
            this.formatOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
          })
          .catch((e) => {
            console.error('Ошибка при загрузке форматов:', e);
          });
    }

    private getStoreRegionsInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
          .then((data) => {
            const filterData = data.data;

            this.regionOptions = filterData.storeRegion
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтные значения в начало
            this.regionOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
          })
          .catch((e) => {
            console.error('Ошибка при загрузке регионов:', e);
          });
    }

    private getStoreClustersInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
          .then((data) => {
            const filterData = data.data;

            this.clusterOptions = filterData.storeCluster
                .map(i => ({ value: i.id, label: i.name }))
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            // Добавляем дефолтные значения в начало
            this.clusterOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
          })
          .catch((e) => {
            console.error('Ошибка при загрузке кластеров:', e);
          });
    }

    private viewReport(id: string) {
        const taskId = parseInt(id);
        if (taskId !== undefined) {
            this.httpLoadTaskById(taskId)
                    .then((resp) => {
                        if (resp.status === 200 && this.canBeShown(resp.data)) {
                            this.selectResult(false, resp.data)
                        } else {
                            this.showInfo(this.$t('resultView.messages.empty') as string);
                            this.$router.push('/reports');
                        }
                    })
                    .catch((ex) => {
                        this.showError(this.$t('resultView.messages.notFound') as string);
                        this.$router.push('/reports');
                    });
        }
    }

    private isFilterDisabled(): boolean {
      const market = this.selectMarket;
      return LocalData.zeroToNull(market) == null;
    }
}
